<template>
  <v-card>
    <v-card-title>Create Account</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-text-field v-model="account.name" :rules="[v => !!v || 'Currency is required']" label="Name" required autofocus></v-text-field>

        <v-select
          v-model="account.currency"
          :items="currencies"
          :rules="[v => !!v || 'Currency is required']"
          label="Currency"
          required
        ></v-select>

        <v-text-field 
          v-model="account.opening_balance"
          type="number" default="0"
          :rules="[v => !!v || 'Required valid balance']" label="Openning Balance"
          :hint = "priceHint" persistent-hint
          required></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <loading-state text="" :state="state"></loading-state>
      <v-btn color="blue darken-1" text v-show="!state.isLoading()" @click="$emit('input', false)">Close</v-btn>
      <v-btn :disabled="(!valid) || state.isLoading()" color="success" class="mr-4" @click="validate">Create</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import Utils from "@/utils"
import { DataState } from "@/state"
import { Account } from "@/models/account"
export default {
  data: () => ({
    state: DataState.newNotInit(),
    account: Account.newEmpty(),
    valid: true,
    currencies: [
      'INR',
      'ISK',
      'EUR',
      'USD',
    ],
    lazy: false,
  }),

  computed: {
    priceHint () {
      if (!this.account.currency) {
        return ''
      }

      let res =  Utils.price(this.account.opening_balance, this.account.currency)
      return res
    }
  },

  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.createAccount()
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    createAccount () {
      this.valid = false
      this.state.changeToLoading()
      this.account.create().then((response) => {
        this.account = response
        this.state.changeToLoaded()
        this.$refs.form.reset()
        this.$emit('created', response)
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
  },
}
</script>